import { PapiroConsole } from "src/utils/papiroConsole";

export default function faqs(state = [], action) {
  switch (action.type) {
    case "ADD_CURRENT":
      return {
        ...state,
        faq: action.faq,
      };
    default:
      return state;
  }
}
